import React, { useState } from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  TextField,
  AppBar,
  Toolbar,
  Paper,
  MenuItem,
} from "@mui/material";

const DEFAULT_IMAGE =
  "http://localhost:5001/uploads/KIET/Logo/KIET-BG.jpg";
// Change above to your actual localhost image URL

export default function BackgroundTestPage() {
  const [imageUrl, setImageUrl] = useState(DEFAULT_IMAGE);
  const [fit, setFit] = useState("contain");
  const [position, setPosition] = useState("center top");
  const [useImgTag, setUseImgTag] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [headerOffset, setHeaderOffset] = useState(true);

  const topValue = headerOffset ? 64 : 0;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#8EC9EA" }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: "rgba(6,45,86,0.55)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Toolbar>
          <Typography sx={{ fontWeight: 800, color: "#fff" }}>
            Background Image Test Page
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          position: "fixed",
          top: topValue,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
          bgcolor: "#8EC9EA",
        }}
      >
        {useImgTag ? (
          <Box
            component="img"
            src={imageUrl}
            alt="Test background"
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: fit,
              objectPosition: position,
            }}
          />
        ) : (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url("${imageUrl}")`,
              backgroundRepeat: "no-repeat",
              backgroundSize: fit,
              backgroundPosition: position,
            }}
          />
        )}

        {showOverlay && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(135deg, rgba(4,27,55,0.22), rgba(25,118,210,0.08))",
            }}
          />
        )}
      </Box>

      <Paper
        sx={{
          position: "relative",
          zIndex: 5,
          width: { xs: "calc(100% - 24px)", md: 460 },
          mx: 2,
          mt: 12,
          p: 2,
          borderRadius: 3,
          bgcolor: "rgba(255,255,255,0.92)",
        }}
      >
        <Stack spacing={2}>
          <Typography sx={{ fontWeight: 800 }}>
            Test Controls
          </Typography>

          <TextField
            label="Image URL"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            fullWidth
            size="small"
          />

          <TextField
            select
            label="Object Fit / Background Size"
            value={fit}
            onChange={(e) => setFit(e.target.value)}
            size="small"
          >
            <MenuItem value="contain">contain</MenuItem>
            <MenuItem value="cover">cover</MenuItem>
            <MenuItem value="fill">fill</MenuItem>
            <MenuItem value="100% 100%">100% 100%</MenuItem>
            <MenuItem value="auto">auto</MenuItem>
          </TextField>

          <TextField
            select
            label="Position"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
            size="small"
          >
            <MenuItem value="center top">center top</MenuItem>
            <MenuItem value="center center">center center</MenuItem>
            <MenuItem value="left top">left top</MenuItem>
            <MenuItem value="right top">right top</MenuItem>
          </TextField>

          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button
              variant={useImgTag ? "contained" : "outlined"}
              onClick={() => setUseImgTag(true)}
            >
              IMG Tag
            </Button>

            <Button
              variant={!useImgTag ? "contained" : "outlined"}
              onClick={() => setUseImgTag(false)}
            >
              CSS Background
            </Button>

            <Button
              variant={showOverlay ? "contained" : "outlined"}
              onClick={() => setShowOverlay((v) => !v)}
            >
              Overlay
            </Button>

            <Button
              variant={headerOffset ? "contained" : "outlined"}
              onClick={() => setHeaderOffset((v) => !v)}
            >
              Header Offset
            </Button>
          </Stack>

          <Typography variant="body2" color="text.secondary">
            Best test for your current issue: use <b>IMG Tag</b>, fit{" "}
            <b>contain</b>, position <b>center top</b>, and turn overlay off.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}